const projectData = [
    {
        id: 1,
        title: "Pet House(E-commerce)",
        description:
            "Pet House is a full-stack E-commerce platform built with the MERN stack, featuring robust authentication. It includes a comprehensive Admin panel for managing products, reviews, and user roles. The user dashboard provides real-time order status tracking and allows customers to submit product reviews.",
        frontendTechnology: [
            { technology: "React.js" },
            { technology: "React Router" },
            { technology: "Firebase" },
            { technology: "Firebase-admin" },
            { technology: "Material UI" },
            { technology: "Heroku" },
        ],
        backendTechnology: [
            { technology: "Node.js" },
            { technology: "Express.js" },
            { technology: "MongoBD.js" },
            { technology: "Rest API" },
        ],
        link: "https://pet-house-3c821.web.app/",
        client: "https://github.com/thejakia1/petHouse-client",
        server: "https://github.com/thejakia1/petHouse-server",
    },
    {
        id: 2,
        title: "Gypsy Travels",
        description:
            "A luxury travel booking platform for planning and reserving tours, featuring comprehensive e-commerce functionalities and a seamless user experience.",
        frontendTechnology: [
            { technology: "React.js" },
            { technology: "React Router" },
            { technology: "Firebase" },
            { technology: "Bootstrap & React-bootstrap" },
            { technology: "Heroku" },
        ],
        backendTechnology: [
            { technology: "Node.js" },
            { technology: "Express.js" },
            { technology: "MongoBD.js" },
            { technology: "Rest API" },
        ],
        link: "https://gypsy-travels.web.app/home",
        client: "https://github.com/thejakia1/gypsyTravels-client",
        server: "https://github.com/thejakia1/gypsyTravels-server",
    },
    {
        id: 3,
        title: "Medicure Healthcare",
        description:
            "Medicure is a healthcare service application that allows users to browse and book various medical services. It includes secure user authentication, personalized dashboards, and detailed service information accessible to logged-in users.",
        frontendTechnology: [
            { technology: "React JS" },
            { technology: "React Navigation" },
            { technology: "React Route" },
            { technology: "Bootstrap" },
        ],
        link: "https://medicure-center.web.app/",
        client: "https://github.com/thejakia1/medicure-healthcare"
    },
    {
        id: 4,
        title: "Language Club (Design)",
        description:
            "A single-page application for a language club, focused on course selection and enrollment. It features a dynamic shopping cart that automatically calculates total costs as users add or remove courses.",
        frontendTechnology: [
            { technology: "React JS" },
            { technology: "React Bootstrap" },
            { technology: "React Route" },
            { technology: "Bootstrap" },
        ],
        link: "https://language-school-thejakia1.netlify.app/",
        client: "https://github.com/thejakia1/language-club"
    },
    {
        id: 5,
        title: "Premier League (Design)",
        description:
            "A fully responsive website design template based on the English Premier League, built with HTML, CSS, and Bootstrap to ensure optimal viewing across all mobile and desktop devices.",
        frontendTechnology: [
            { technology: "Bootstrap" },
            { technology: "CSS" },
            { technology: "HTML" }
        ],
        link: "https://thejakia1.github.io/football-website/",
        client: "https://github.com/thejakia1/football-website"
    }
];

export default projectData;
